// Khởi tạo sớm, không cần đợi window load.
(function initFloatLeftNav() {
    if ($('#MS__wrapper.iframe').length) return; // Bỏ qua trong iframe embed

    const maxTries = 120; // Giới hạn retry ~2s (120 * (~16ms rAF))
    let tries = 0;

    function raf(fn){
        (window.requestAnimationFrame || function(cb){return setTimeout(cb,16);} )(fn);
    }

    function tryInit() {
        const $swiperWrap = $('.main-swiper');
        if (!$swiperWrap.length) return schedule();
        const host = $swiperWrap[0];
        const swiper = host && host.swiper;
        if (!swiper) return schedule();
        const $navItems = $('#libraryMainsite-t-float_left .nav-box .nav');
        if (!$navItems.length) return schedule();

        // Slide đích của từng item: ưu tiên data-slide, không có thì lấy đúng thứ tự item.
        // Mainsite dùng data-slide vì số item menu ít hơn số slide (menu chỉ trỏ vài frame).
        function targetSlide($item, idx){
            const ds = parseInt($item.attr('data-slide'), 10);
            return Number.isInteger(ds) && ds >= 0 ? ds : idx;
        }

        function updateActiveNav(i){
            $navItems.removeClass('active');
            $navItems.filter(function(idx){
                return targetSlide($(this), idx) === i;
            }).first().addClass('active');
        }

        updateActiveNav(swiper.activeIndex || 0);
        swiper.on('slideChange', function(){ updateActiveNav(swiper.activeIndex); });

        $navItems.each(function(idx){
            const $item = $(this);
            $item.off('click.__flnav').on('click.__flnav', function(e){
                    // Nếu click vào thẻ <a> bên trong thì cho đi link bình thường
                    if ($(e.target).is('a')) {
                        return;
                    }
                    e.preventDefault();
                    swiper.slideTo(targetSlide($item, idx));
            });
        });
    }

    function schedule(){
        if (++tries > maxTries) return; // dừng nếu quá số lần
        raf(tryInit);
    }

    tryInit();
})();
